import React from "react";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "../../css/Navbar.css";
import HeaderImage from "../../assets/icons/Navbar_Logo.svg";

const Navbar = () => {
  const location = useLocation();
  const isSchoolPage = location.pathname === "/for-schools";

  return (
    <header className="main-header">
      <div className="header-logo">
        <Link to="/">
          <img src={HeaderImage} alt="School Fees Protection Plan Logo" />
        </Link>
      </div>

      <div className="header-nav">
        <Link
          smooth
          // to={isSchoolPage ? "/#home" : "/#home"}
          to="/"
          className="nav-regular"
        >
          Home
        </Link>

        <HashLink
          smooth
          to={isSchoolPage ? "/for-schools#why-choose-us" : "/#why-choose-us"}
          className="nav-regular"
        >
          Why choose us
        </HashLink>

        {/* <HashLink
          smooth
          to={isSchoolPage ? "/for-schools#mission" : "/#mission"}
          className="nav-regular"
        >
          Our mission
        </HashLink> */}

        <HashLink
          smooth
          to={isSchoolPage ? "/for-schools#contact" : "/#contact"}
          className="nav-regular"
        >
          Contact us
        </HashLink>
      </div>
    </header>
  );
};

export default Navbar;
